export const AUTH_CHANGED_EVENT = "recruit_ai_auth_changed";

export function notifyAuthChanged() {
  window.dispatchEvent(new Event(AUTH_CHANGED_EVENT));
}
